import { styled } from '@mui/system';
import { AgColor } from '../../../stories/Styles/AgColor';

export const Main = styled('main')`
  position: relative;
  padding: 16px 32px;
  display: grid;
  gap: 16px;
`;

export const Container = styled('section')`
  width: calc(100vw - 290px);

  .MuiDataGrid-columnHeader:nth-of-type(2),
  .MuiDataGrid-cell:nth-of-type(2) {
    border-right: 0 !important;
  }

  .MuiDataGrid-columnHeader:nth-of-type(1),
  .MuiDataGrid-cell:nth-of-type(1) {
    border-right: .25px solid ${AgColor.grey4};
  }
`;